import React from 'react';
import { FieldWrapper } from './fieldWrapper';
import { AntInput } from '../../../ant/antInput';
import { Property } from '../models';
import { observer } from 'mobx-react';
import { FormBuilderContext } from '../formBuilderContext';
import { AntFlex } from 'controls/react/ant/antFlex';
import { FolderOpenFilled } from '@ant-design/icons';
import b_ from 'b_';
import './ceFileChooser.less';
import { AntButton } from 'controls/react/ant/antButton';
import CEFileChooserWindow from 'controls/react/form/ceFileChooserWindow';
import { apiFetch } from 'framework/api';
import { cloneDeep, set } from 'lodash';

const b = b_.with('ce-file-chooser');

interface FileEntry {
	folder: boolean;
	text: string;
	path: string;
}

export const CEFileChooser = observer(({ property }: { property: Property }) => {
	const store = React.useContext(FormBuilderContext);
	const disabled = store.propertyDisabled(property);

	const [showWindow, setShowWindow] = React.useState(false);

	const value = store.value[property.id] as string;

	const handleSave = React.useCallback((dir: string, file: string) => {
		setShowWindow(false);
		store.onPropertyValueChange(property, dir);

		const fileNameProperty = store.allProperties.find((x) => x.id == 'fileName');
		if (file && fileNameProperty) {
			store.onPropertyValueChange(fileNameProperty, file);
		}
	}, []);

	const handleCancel = React.useCallback(() => {
		setShowWindow(false);
	}, []);

	const handleOpen = React.useCallback(() => {
		setShowWindow(true);
	}, []);

	const onLoad = React.useCallback(
		async (initialDirectory: string) => {
			const items = (await apiFetch(
				store.getPropertyData(property, (value, fullPath) => {
					const result = cloneDeep(value);
					set(result, fullPath, { initialDirectory });
					return result;
				}),
			)) as unknown as { data: FileEntry[] };

			return items.data.map((item: FileEntry) => {
				return {
					title: item.text || item.path,
					key: item.path,
					isLeaf: !item.folder,
				};
			});
		},
		[store.value, store.getPropertyData, property.id],
	);

	return (
		<>
			<AntFlex justify="space-between" gap="10px" align="stretch">
				<FieldWrapper property={property} className={b('input')}>
					<AntInput onBlur={() => store.onPropertyBlur(property)} readOnly={true} />
				</FieldWrapper>
				<AntButton className={b('button')} disabled={disabled} onClick={handleOpen}>
					<FolderOpenFilled className={b('icon')} />
				</AntButton>
			</AntFlex>
			{showWindow && (
				<div>
					<CEFileChooserWindow
						directoriesOnly={property.directoriesOnly}
						value={value}
						// fileName={fileName}
						onLoad={onLoad}
						onSave={handleSave}
						onCancel={handleCancel}
					/>
				</div>
			)}
		</>
	);
});
